import React, { FC, Fragment, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LabOrderContext } from 'pages/order-flow/lab-order/lab-order-context';
import { Box, Button, Chip } from '@mui/material';
import { emptyConstruction } from '../../constructions-helper';

type ManageConstructionsProps = {
    onSelectedConstructionChange: (index: number) => void;
};
const ManageConstructions: FC<ManageConstructionsProps> = ({ onSelectedConstructionChange }) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    const { order, setOrder } = useContext(LabOrderContext);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const onChipClick = (index: number) => {
        if (selectedIndex !== index) {
            setSelectedIndex(index);
            onSelectedConstructionChange(index);
        }
    };

    const onAddConstructionClick = () => {
        setOrder((prev) => {
            return {
                ...prev,
                constructions: [...prev.constructions, emptyConstruction()],
            };
        });
        setSelectedIndex(order.constructions.length);
        onSelectedConstructionChange(order.constructions.length);
    };

    const onDeleteClick = (index: number) => {
        setOrder((prev) => {
            const newConstructions = [...prev.constructions];
            newConstructions.splice(index, 1);
            return {
                ...prev,
                constructions: newConstructions,
            };
        });
        setSelectedIndex(0);
        onSelectedConstructionChange(0);
    };

    return (
        <Fragment>
            <Box display="flex">
                {order.constructions.map((_, index) => (
                    <Chip
                        key={index}
                        color={selectedIndex === index ? 'primary' : undefined}
                        label={`${translate('orders:PART')} ${index + 1}`}
                        onClick={() => onChipClick(index)}
                        onDelete={order.constructions.length > 1 ? () => onDeleteClick(index) : undefined}
                        sx={{ marginRight: 1 }}
                        data-test={`manage-constructions.part-chip-${index}`}
                    />
                ))}
                {!order.scannerCase ? (
                    <Button
                        size="small"
                        onClick={() => onAddConstructionClick()}
                        data-test="manage-constructions.add-part"
                    >
                        {translate('orders:ADD_PART')}
                    </Button>
                ) : undefined}
            </Box>
        </Fragment>
    );
};

export default ManageConstructions;
